import * as React from "react";
import { Element, ElementRowContainer } from "../labels/binary/BinaryLabelWidget";
import FontAwesome from "react-fontawesome";
import { PREDICATE } from "./ConstantNames";
import { Button } from "react-bootstrap";
export class NaryListWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement(ElementRowContainer, {
      key: this.props.elementName
    }, /*#__PURE__*/React.createElement(Element, {
      title: this.props.type === PREDICATE ? "Predikát" : "Funkcia"
    }, this.props.elementName), /*#__PURE__*/React.createElement(Button, {
      className: 'btn-graph',
      variant: "outline-warning",
      title: "Zmazať " + (this.props.type === PREDICATE ? "daný predikát" : "danú funkciu") + " z vrcholu",
      onClick: () => {
        this.props.type === PREDICATE ? this.props.model.removePredicate(this.props.elementName) : this.props.model.removeFunction(this.props.elementName);
        this.props.engine.repaintCanvas();
      }
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "fas fa-trash"
    })));
  }

}